import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { ConfirmButton } from "../../components/ConfirmButton";
import { QrScannerModal } from "../../components/QrScannerModal";
import { notification } from "../../helpers/notification";
import {
    checkEventPersonnel,
    getEventPersonnels,
    updateEventPersonnel,
} from "../../services/eventPersonnelServices";
import { getEvent } from "../../services/eventServices";
import { getEventSupplierPersonnelRequests } from "../../services/eventSupplierPersonnelRequestServices";

export const EventPersonnelRegister = () => {
    const { uniqueKey } = useParams();
    const [event, setEvent] = useState({});
    const [oldPersonnelList, setOldPersonnelList] = useState([]);
    const [personnelList, setPersonnelList] = useState([]);
    const [personnel, setPersonnel] = useState();
    const [supplierList, setSupplierList] = useState([]);
    const [tableItems, setTableItems] = useState([]);
    const [identityValue, setIdentityValue] = useState("");
    const [vestNoValue, setVestNoValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [isQrScannerOpen, setIsQrScannerOpen] = useState(false);
    const [searchText, setSearchText] = useState({ name: "", surname: "", vestNo: "", identityNumber: "", oggNumber: "", eventSupplierName: "" });
    const [mobileSearch, setMobileSearch] = useState("");
    const [editingVestNo, setEditingVestNo] = useState(null);
    const [editingVestNoValue, setEditingVestNoValue] = useState("");
    const identityNoRef = useRef(null);
    const vestNoRef = useRef(null);

    const handleSearchFilter = (field, value) => {
        setSearchText(prev => ({ ...prev, [field]: value }));
    };

    const getData = () => {
        getEvent(uniqueKey).then((result) => {
            setEvent(result);
        });
        getEventPersonnels(uniqueKey).then((result) => {
            getEventSupplierPersonnelRequests(uniqueKey).then((requestResult) => {
                const items = [];
                requestResult.items.forEach((item, i) => {
                    items.push({
                        key: i.toString(),
                        label: item.supplierName,
                        required: item.oggCount + item.chiefCount,
                        attended: result.items.filter(
                            (f) =>
                                f.isAttended &&
                                f.eventSupplierUniqueKey ==
                                    item.supplierUniqueKey
                        ).length,
                    });
                });
                setTableItems(items);
                setSupplierList(requestResult.items);
            });
            result.items.map(m => {
                if (m.updatedDate == null)
                    m.updatedDate = moment().add(1, 'day');
                return m;
            });
            setOldPersonnelList(result.items);
            setPersonnelList(result.items);
        });
    };

    const onDeleteConfirm = (uniqueKey) => {
        setLoading(true);
        updateEventPersonnel({
            uniqueKey: uniqueKey,
            isAttended: false,
        }).then(() => {
            let newPersonelList = [];
            personnelList.forEach((item) => {
                if (item.uniqueKey == uniqueKey) {
                    item.isAttended = false;
                }
                newPersonelList.push(item);
            });
            setPersonnelList(newPersonelList);
            const items = [];
            supplierList.forEach((item, i) => {
                const attendedCount = newPersonelList.filter(
                    (f) => f.isAttended && f.eventSupplierUniqueKey == item.supplierUniqueKey
                ).length;
                items.push({
                    key: i.toString(),
                    label: item.supplierName,
                    required: item.oggCount + item.chiefCount,
                    attended: attendedCount,
                });
            });
            setTableItems(items);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleVestNoSave = (record) => {
        if (!editingVestNoValue || editingVestNoValue == "") return;
        setLoading(true);
        updateEventPersonnel({
            uniqueKey: record.uniqueKey,
            vestNo: editingVestNoValue
        }).then(() => {
            const newList = [];
            personnelList.forEach((item) => {
                if (item.uniqueKey == record.uniqueKey)
                    item.vestNo = editingVestNoValue;
                newList.push(item);
            });
            setPersonnelList(newList);
            setEditingVestNo(null);
            setEditingVestNoValue("");
        }).finally(() => {
            setLoading(false);
        });
    };

    const processBarcodeScan = (barcodeVal) => {
        if (!barcodeVal) return;
        const cleanVal = barcodeVal.toString().trim();
        setIdentityValue(cleanVal);

        const subdomain = window.location.host.split('.')[0];
        let itemUniqueKey = "";
        let item_ = null;

        personnelList.forEach((item) => {
            if (item.identityNumber == cleanVal) {
                itemUniqueKey = item.uniqueKey;
                item_ = item;
            }
        });

        setLoading(true);
        checkEventPersonnel({
            uniqueKey: itemUniqueKey,
            eventUniqueKey: uniqueKey
        }).then((res) => {
            if (res.status == "notfound") {
                itemUniqueKey = "";
                notification.warning({
                    message: "Okutulan barkoda ait personel akredite listesinde bulunamadı.",
                });
                if (identityNoRef.current) identityNoRef.current.focus({ cursor: 'all' });
            } else if (res.status == "attended") {
                itemUniqueKey = "";
                notification.warning({
                    message: "Personel daha önceden kayıt edilmiş.",
                });
                if (identityNoRef.current) identityNoRef.current.focus({ cursor: 'all' });
            } else if (res.status == "full") {
                itemUniqueKey = "";
                if (subdomain == "elze") {
                    notification.warning({
                        message: "Tedarikçinin personel kapasitesi dolmuştur.",
                    });
                    if (identityNoRef.current) identityNoRef.current.focus({ cursor: 'all' });
                } else {
                    if (window.confirm("Tedarikçinin personel kapasitesi dolmuştur. Yine de ekleme işlemine devam etmek istiyor musunuz ?")) {
                        setPersonnel(item_);
                        if (vestNoRef.current) vestNoRef.current.focus({ cursor: 'start' });
                    } else {
                        itemUniqueKey = "";
                        if (identityNoRef.current) identityNoRef.current.focus({ cursor: 'all' });
                    }
                }
            } else {
                setPersonnel(item_);
                if (vestNoRef.current) vestNoRef.current.focus({ cursor: 'start' });
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleQrScanSuccess = (decodedText) => {
        setIsQrScannerOpen(false);
        processBarcodeScan(decodedText);
    };

    const readBarcode = (e, isBarcode) => {
        if (e.keyCode == 13 || e.keyCode === 9) {
            const subdomain = window.location.host.split('.')[0];
            let newPersonelList = [];
            let foundPersonnel = null;
            let hasPersonnel = false;
            let personnelAlreadyExist = false;
            let itemUniqueKey = "";

            if (isBarcode) {
                processBarcodeScan(e.target.value);
            } else {
                if (personnel) {
                    var vestNo = e.target.value;
                    setLoading(true);

                    if (subdomain == "elze") {
                        checkEventPersonnel({
                            uniqueKey: personnel.uniqueKey,
                            eventUniqueKey: uniqueKey
                        }).then((res) => {
                            if (res.status == "available") {
                                updateEventPersonnel({
                                    uniqueKey: personnel.uniqueKey,
                                    isAttended: true,
                                    vestNo: e.target.value,
                                }).then(() => {
                                    personnelList.forEach((item) => {
                                        if (item.identityNumber == personnel.identityNumber) {
                                            item.isAttended = true;
                                            item.vestNo = vestNo;
                                            item.updatedDate = moment();
                                            itemUniqueKey = item.uniqueKey;
                                        }
                                        newPersonelList.push(item);
                                    });
                                    setPersonnelList(newPersonelList);
                                    const items = [];
                                    supplierList.forEach((item, i) => {
                                        const attendedCount = newPersonelList.filter(
                                            (f) => f.isAttended && f.eventSupplierUniqueKey == item.supplierUniqueKey
                                        ).length;
                                        items.push({
                                            key: i.toString(),
                                            label: item.supplierName,
                                            required: item.oggCount + item.chiefCount,
                                            attended: attendedCount,
                                        });
                                    });
                                    setTableItems(items);
                                    setPersonnel(null);
                                    identityNoRef.current.focus({ cursor: 'start' });
                                    setIdentityValue("");
                                    setVestNoValue("");
                                }).catch((e) => {
                                    notification.warning({
                                        message: "Bir hata oluştu tekrar deneyiniz.(" + e.message + ")",
                                    });
                                }).finally(() => {
                                    setLoading(false);
                                });
                            } else if (res.status == "full") {
                                notification.warning({
                                    message: "Tedarikçinin personel kapasitesi dolmuştur. Yelek no okutulamaz.",
                                });
                                setPersonnel(null);
                                identityNoRef.current.focus({ cursor: 'all' });
                            } else {
                                notification.warning({
                                    message: "Personel daha önceden kayıt edilmiş.",
                                });
                                setPersonnel(null);
                                identityNoRef.current.focus({ cursor: 'all' });
                            }
                        });
                    } else {
                        updateEventPersonnel({
                            uniqueKey: personnel.uniqueKey,
                            isAttended: true,
                            vestNo: e.target.value,
                        }).then(() => {
                            setIdentityValue("");
                            setVestNoValue("");
                            personnelList.forEach((item) => {
                                if (item.identityNumber == personnel.identityNumber) {
                                    item.isAttended = true;
                                    item.vestNo = vestNo;
                                    item.updatedDate = moment().local().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
                                    itemUniqueKey = item.uniqueKey;
                                }
                                newPersonelList.push(item);
                            });
                            setPersonnelList(newPersonelList);
                            const items = [];
                            supplierList.forEach((item, i) => {
                                const attendedCount = newPersonelList.filter(
                                    (f) => f.isAttended && f.eventSupplierUniqueKey == item.supplierUniqueKey
                                ).length;
                                items.push({
                                    key: i.toString(),
                                    label: item.supplierName,
                                    required: item.oggCount + item.chiefCount,
                                    attended: attendedCount,
                                });
                            });
                            setTableItems(items);
                            setPersonnel(null);
                            identityNoRef.current.focus({ cursor: 'start' });
                        }).catch((e) => {
                            notification.warning({
                                message: "Bir hata oluştu tekrar deneyiniz.(" + e.message + ")",
                            });
                        }).finally(() => {
                            setLoading(false);
                        });
                    }
                }
            }
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const filteredAttended = personnelList
        .filter((f) => {
            if (!f.isAttended) return false;
            if (mobileSearch) {
                const s = mobileSearch.trim().toLocaleLowerCase('tr-TR');
                const match =
                    (f.name && f.name.toLocaleLowerCase('tr-TR').includes(s)) ||
                    (f.surname && f.surname.toLocaleLowerCase('tr-TR').includes(s)) ||
                    (f.vestNo && f.vestNo.toString().toLocaleLowerCase('tr-TR').includes(s)) ||
                    (f.identityNumber && f.identityNumber.toString().toLocaleLowerCase('tr-TR').includes(s)) ||
                    (f.oggNumber && f.oggNumber.toString().toLocaleLowerCase('tr-TR').includes(s)) ||
                    (f.eventSupplierName && f.eventSupplierName.toLocaleLowerCase('tr-TR').includes(s));
                if (!match) return false;
            }
            for (const key of Object.keys(searchText)) {
                if (searchText[key]) {
                    const val = f[key] ? f[key].toString().toLocaleLowerCase('tr-TR') : "";
                    const searchVal = searchText[key].toString().trim().toLocaleLowerCase('tr-TR');
                    if (!val.includes(searchVal)) return false;
                }
            }
            return true;
        })
        .sort((a, b) => moment(b.updatedDate) - moment(a.updatedDate))
        .map((n, index) => {
            n.index = index + 1;
            return n;
        });

    const totalCount = event?.totalPersonnelCount || 0;
    const attendedCount = personnelList.filter((f) => f.isAttended).length;
    const remainingCount = totalCount - attendedCount;
    const attendanceRate = totalCount > 0 ? Math.min(100, Math.round((attendedCount / totalCount) * 100)) : 0;

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            {loading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white dark:bg-gray-900 rounded-lg p-6 flex items-center gap-3 shadow-lg">
                        <svg className="animate-spin h-6 w-6 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span className="text-gray-700 dark:text-gray-300 font-medium">Yükleniyor...</span>
                    </div>
                </div>
            )}
            <div className="max-w-7xl mx-auto px-3 sm:px-4 py-3 sm:py-6">
                <div className="mb-4 sm:mb-6">
                    <div className="flex items-center justify-between gap-2 mb-2 sm:mb-4">
                        <div className="min-w-0">
                            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 dark:text-gray-100 truncate">{event.name}</h1>
                            {event.notes && (
                                <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5 truncate" title={event.notes}>
                                    <span className="font-medium text-gray-700 dark:text-gray-300">Not:</span> {event.notes}
                                </p>
                            )}
                        </div>
                        <span className="text-xs sm:text-sm font-medium text-gray-500 dark:text-gray-400 shrink-0">
                            Katılım: <span className="font-semibold text-gray-900 dark:text-gray-100">%{attendanceRate}</span>
                        </span>
                    </div>

                    <div className="grid grid-cols-3 gap-2 sm:gap-4">
                        {/* Toplam Sayı */}
                        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg sm:rounded-xl p-2.5 sm:p-4 shadow-sm flex items-center justify-between">
                            <div className="min-w-0">
                                <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 truncate">SAYI</p>
                                <p className="text-lg sm:text-3xl font-extrabold text-gray-900 dark:text-gray-100 mt-0.5 sm:mt-1">{totalCount}</p>
                            </div>
                            <div className="hidden sm:flex w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 items-center justify-center shrink-0">
                                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                                </svg>
                            </div>
                        </div>

                        {/* Giriş Yapan */}
                        <div className="bg-green-50/70 dark:bg-green-950/30 border border-green-200 dark:border-green-800/60 rounded-lg sm:rounded-xl p-2.5 sm:p-4 shadow-sm flex items-center justify-between">
                            <div className="min-w-0">
                                <p className="text-[10px] sm:text-xs font-semibold uppercase tracking-wider text-green-700 dark:text-green-300 truncate">GİRİŞ YAPAN</p>
                                <p className="text-lg sm:text-3xl font-extrabold text-green-700 dark:text-green-400 mt-0.5 sm:mt-1">{attendedCount}</p>
                            </div>
                            <div className="hidden sm:flex w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300 items-center justify-center shrink-0">
                                <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>

                        {/* Kalan */}
                        <div className={`${remainingCount <= 0 ? 'bg-green-50/70 dark:bg-green-950/30 border-green-200 dark:border-green-800/60' : 'bg-red-50/70 dark:bg-red-950/30 border-red-200 dark:border-red-800/60'} border rounded-lg sm:rounded-xl p-2.5 sm:p-4 shadow-sm flex items-center justify-between`}>
                            <div className="min-w-0">
                                <p className={`text-[10px] sm:text-xs font-semibold uppercase tracking-wider ${remainingCount <= 0 ? 'text-green-700 dark:text-green-300' : 'text-red-700 dark:text-red-300'} truncate`}>KALAN</p>
                                <p className={`text-lg sm:text-3xl font-extrabold ${remainingCount <= 0 ? 'text-green-700 dark:text-green-400' : 'text-red-700 dark:text-red-400'} mt-0.5 sm:mt-1`}>
                                    {remainingCount}
                                </p>
                            </div>
                            <div className={`hidden sm:flex w-10 h-10 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl ${remainingCount <= 0 ? 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300' : 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300'} items-center justify-center shrink-0`}>
                                {remainingCount <= 0 ? (
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                ) : (
                                    <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                    </svg>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Katılım İlerleme Çubuğu */}
                    {totalCount > 0 && (
                        <div className="mt-2 sm:mt-3 bg-gray-200 dark:bg-gray-700 rounded-full h-1.5 sm:h-2 overflow-hidden">
                            <div
                                className="bg-green-500 h-1.5 sm:h-2 rounded-full transition-all duration-300"
                                style={{ width: `${attendanceRate}%` }}
                            />
                        </div>
                    )}
                </div>

                <div className="mb-4 sm:mb-6">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2 sm:gap-4 mb-3 sm:mb-4">
                        {supplierList.map((item, i) => {
                            const addedPersonnelCount = oldPersonnelList.filter(
                                (f) => f.isAttended && f.eventSupplierUniqueKey == item.supplierUniqueKey
                            ).length;
                            const isFull = (item.oggCount + item.chiefCount) == addedPersonnelCount;
                            return (
                                <div key={i} className="bg-white dark:bg-gray-800 rounded-lg p-2 sm:p-3 shadow-sm border border-gray-200 dark:border-gray-700">
                                    <div className="text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 truncate" title={item.supplierName}>{item.supplierName}</div>
                                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] sm:text-xs font-medium ${isFull ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                                        {item.oggCount + item.chiefCount} / {addedPersonnelCount}
                                    </span>
                                </div>
                            );
                        })}
                    </div>

                    <hr className="my-3 sm:my-4 border-gray-200 dark:border-gray-700" />

                    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-3 sm:p-4 mb-3 sm:mb-4">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-4">
                            <div className="md:col-span-4">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Barkod</label>
                                <div className="flex items-center gap-2">
                                    <input
                                        autoFocus
                                        ref={identityNoRef}
                                        type="text"
                                        value={identityValue}
                                        onChange={(e) => setIdentityValue(e.target.value)}
                                        onKeyDown={(e) => readBarcode(e, true)}
                                        placeholder="Okutulacak Barkod"
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                    />
                                    {/* Sadece mobil ve tablet cihazlarda (ekran 1024px altı) görünen QR Tarama butonu */}
                                    <button
                                        type="button"
                                        onClick={() => setIsQrScannerOpen(true)}
                                        className="lg:hidden shrink-0 inline-flex items-center justify-center gap-1.5 px-3 py-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-lg text-sm font-medium transition shadow-sm active:scale-95"
                                        title="Kamera ile QR / Barkod Tara"
                                    >
                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" />
                                        </svg>
                                        <span className="hidden sm:inline">QR Tara</span>
                                    </button>
                                </div>
                            </div>
                            <div className="md:col-span-2">
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Yelek No</label>
                                <input
                                    ref={vestNoRef}
                                    type="text"
                                    value={vestNoValue}
                                    onChange={(e) => setVestNoValue(e.target.value)}
                                    onKeyDown={(e) => readBarcode(e, false)}
                                    placeholder="Yelek No"
                                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                                />
                            </div>
                            <div className="md:col-span-6">
                                {personnel && (
                                    <>
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Okutulan Personel</label>
                                        <div className="text-sm text-gray-900 dark:text-gray-100 font-semibold py-2">
                                            {personnel.name} {personnel.surname} - {personnel.oggNumber + (personnel.isRetired ? " (Emekli)" : "")} - {moment(personnel.birthDate).format("DD.MM.YYYY")}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {personnelList.filter((f) => f.isAttended).length === 0 ? (
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-8 text-center text-gray-500 dark:text-gray-400">
                            Henüz personel kayıt edilmemiş.
                        </div>
                    ) : (
                        <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
                            {/* MOBİL GÖRÜNÜM (Kart Listesi - Sadece md altındaki mobil ekranlarda) */}
                            <div className="block md:hidden">
                                {/* Mobil Arama Çubuğu */}
                                <div className="p-3 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/60">
                                    <div className="relative">
                                        <input
                                            type="text"
                                            value={mobileSearch}
                                            onChange={(e) => setMobileSearch(e.target.value)}
                                            placeholder="Personel ara (Ad, soyad, yelek, TC)..."
                                            className="w-full pl-9 pr-8 py-2 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500"
                                        />
                                        <svg className="w-4 h-4 text-gray-400 absolute left-2.5 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                        </svg>
                                        {mobileSearch && (
                                            <button
                                                type="button"
                                                onClick={() => setMobileSearch("")}
                                                className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                            >
                                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                    <div className="flex items-center justify-between mt-2 text-[11px] text-gray-500 dark:text-gray-400 px-0.5">
                                        <span>Kayıtlı: <strong className="text-gray-800 dark:text-gray-200 font-semibold">{filteredAttended.length}</strong> personel</span>
                                        {filteredAttended.length > 0 && <span className="text-[10px] text-gray-400">Son eklenen en üstte</span>}
                                    </div>
                                </div>

                                {filteredAttended.length === 0 ? (
                                    <div className="p-6 text-center text-xs text-gray-500 dark:text-gray-400">
                                        Aranan kriterlere uygun personel bulunamadı.
                                    </div>
                                ) : (
                                    <div className="divide-y divide-gray-200 dark:divide-gray-700">
                                        {filteredAttended.map((record) => (
                                            <div key={record.uniqueKey} className="p-3 bg-white dark:bg-gray-800 flex flex-col gap-2">
                                                {/* Üst Satır: Sıra, Ad Soyad, Görev ve Silme Butonu */}
                                                <div className="flex items-start justify-between gap-2">
                                                    <div className="flex items-center gap-2 min-w-0">
                                                        <span className="w-5 h-5 rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-[11px] font-bold flex items-center justify-center shrink-0">
                                                            {record.index}
                                                        </span>
                                                        <div className="min-w-0">
                                                            <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100 truncate">
                                                                {record.name} {record.surname}
                                                            </h4>
                                                            <p className="text-[11px] text-gray-500 dark:text-gray-400 truncate">
                                                                {(record.personnelType == "1" ? "Amir" : record.personnelType == "3" ? "Özel Güvenlik Sorumlusu" : "Özel Güvenlik") + (record.isRetired ? " (Emekli)" : "")}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Silme Butonu */}
                                                    <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Personeli listeden çıkartmak istediğinizden emin misiniz ?">
                                                        <button className="text-red-500 hover:text-red-700 p-1 rounded hover:bg-red-50 dark:hover:bg-red-950/30 transition shrink-0" title="Listeden Çıkart">
                                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                            </svg>
                                                        </button>
                                                    </ConfirmButton>
                                                </div>

                                                {/* Detay Bilgileri ve Yelek No */}
                                                <div className="bg-gray-50 dark:bg-gray-900/50 rounded-lg p-2.5 border border-gray-100 dark:border-gray-700/60 flex flex-col gap-2">
                                                    {/* Yelek No Satırı */}
                                                    <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700/60 pb-1.5">
                                                        <span className="text-[11px] font-medium text-gray-500 dark:text-gray-400">Yelek No:</span>
                                                        {editingVestNo === record.uniqueKey ? (
                                                            <div className="flex items-center gap-1">
                                                                <input
                                                                    type="number"
                                                                    value={editingVestNoValue}
                                                                    onChange={(e) => setEditingVestNoValue(e.target.value)}
                                                                    onKeyDown={(e) => { if (e.key === 'Enter') handleVestNoSave(record); if (e.key === 'Escape') setEditingVestNo(null); }}
                                                                    className="w-16 border border-gray-300 rounded px-1.5 py-0.5 text-xs bg-white text-gray-900"
                                                                    autoFocus
                                                                />
                                                                <button onClick={() => handleVestNoSave(record)} className="text-green-600 hover:text-green-800 p-0.5">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" /></svg>
                                                                </button>
                                                                <button onClick={() => setEditingVestNo(null)} className="text-gray-400 hover:text-gray-600 p-0.5">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                onClick={() => { setEditingVestNo(record.uniqueKey); setEditingVestNoValue(record.vestNo || ""); }}
                                                                className="inline-flex items-center gap-1 cursor-pointer bg-blue-50 dark:bg-blue-950/40 text-blue-700 dark:text-blue-300 font-bold px-2 py-0.5 rounded text-xs hover:bg-blue-100"
                                                            >
                                                                <span>{record.vestNo ? `#${record.vestNo}` : "Girilmedi"}</span>
                                                                <svg className="w-3 h-3 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* 2x2 Grid Detaylar */}
                                                    <div className="grid grid-cols-2 gap-2 text-xs">
                                                        <div>
                                                            <span className="text-[10px] text-gray-400 uppercase block">TC Kimlik</span>
                                                            <span className="font-medium text-gray-900 dark:text-gray-100 text-[11px]">{record.identityNumber}</span>
                                                        </div>
                                                        <div>
                                                            <span className="text-[10px] text-gray-400 uppercase block">ÖGG No</span>
                                                            <span className="font-medium text-gray-900 dark:text-gray-100 text-[11px]">
                                                                {record.oggNumber || "-"}
                                                                {record.oggExpireDate && (
                                                                    <span className="text-[10px] text-blue-600 dark:text-blue-400 block">
                                                                        Bit: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="text-[10px] text-gray-400 uppercase block">Doğum Tarihi</span>
                                                            <span className="font-medium text-gray-900 dark:text-gray-100 text-[11px]">
                                                                {record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="text-[10px] text-gray-400 uppercase block">Şirket</span>
                                                            <span className="font-medium text-gray-900 dark:text-gray-100 text-[11px] truncate block" title={record.eventSupplierName}>
                                                                {record.eventSupplierName}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* MASAÜSTÜ TABLO GÖRÜNÜMÜ (Orijinal haliyle aynen korundu) */}
                            <div className="hidden md:block overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 text-sm">
                                    <thead className="bg-gray-50 dark:bg-gray-800">
                                        <tr>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase w-12">#</th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>Adı</div>
                                                <input type="text" value={searchText.name} onChange={(e) => { handleSearchFilter('name', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>Soyadı</div>
                                                <input type="text" value={searchText.surname} onChange={(e) => { handleSearchFilter('surname', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>Yelek No</div>
                                                <input type="text" value={searchText.vestNo} onChange={(e) => { handleSearchFilter('vestNo', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>TC Kimlik</div>
                                                <input type="text" value={searchText.identityNumber} onChange={(e) => { handleSearchFilter('identityNumber', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>ÖGG Numarası</div>
                                                <input type="text" value={searchText.oggNumber} onChange={(e) => { handleSearchFilter('oggNumber', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">D.Tarihi</th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Görevi</th>
                                            <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                                <div>Şirket</div>
                                                <input type="text" value={searchText.eventSupplierName} onChange={(e) => { handleSearchFilter('eventSupplierName', e.target.value); }} placeholder="Ara..." className="mt-1 w-full border border-gray-300 dark:border-gray-600 rounded px-2 py-1 text-xs font-normal normal-case bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 outline-none focus:ring-1 focus:ring-blue-500" />
                                            </th>
                                            <th className="px-3 py-3 w-12"></th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                        {filteredAttended.length === 0 ? (
                                            <tr>
                                                <td colSpan="10" className="px-3 py-6 text-center text-gray-500 dark:text-gray-400">
                                                    Aranan kriterlere uygun personel bulunamadı.
                                                </td>
                                            </tr>
                                        ) : (
                                            filteredAttended.map((record) => (
                                                <tr key={record.uniqueKey} className="hover:bg-gray-50 dark:hover:bg-gray-700 dark:bg-gray-800">
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.index}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.name}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.surname}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                                        {editingVestNo === record.uniqueKey ? (
                                                            <div className="flex items-center gap-1">
                                                                <input
                                                                    type="number"
                                                                    value={editingVestNoValue}
                                                                    onChange={(e) => setEditingVestNoValue(e.target.value)}
                                                                    onKeyDown={(e) => { if (e.key === 'Enter') handleVestNoSave(record); if (e.key === 'Escape') setEditingVestNo(null); }}
                                                                    className="w-20 border border-gray-300 rounded px-2 py-1 text-xs"
                                                                    autoFocus
                                                                />
                                                                <button onClick={() => handleVestNoSave(record)} className="text-green-600 hover:text-green-800">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                                                </button>
                                                                <button onClick={() => setEditingVestNo(null)} className="text-gray-400 hover:text-gray-600">
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="flex items-center gap-1 cursor-pointer group">
                                                                <span>{record.vestNo}</span>
                                                                <button
                                                                    onClick={() => { setEditingVestNo(record.uniqueKey); setEditingVestNoValue(record.vestNo || ""); }}
                                                                    className="text-gray-400 hover:text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity"
                                                                >
                                                                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"></path></svg>
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.identityNumber}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">
                                                        <div className="inline-flex items-center gap-1.5">
                                                            <span>{record.oggNumber || "-"}</span>
                                                            {record.oggExpireDate && (
                                                                <span
                                                                    className="relative group inline-flex items-center cursor-pointer text-blue-500 hover:text-blue-600"
                                                                    title={`ÖGG Bitiş Tarihi: ${moment(record.oggExpireDate).format("DD.MM.YYYY")}`}
                                                                >
                                                                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                                    </svg>
                                                                    <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:flex px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50 pointer-events-none">
                                                                        Bitiş: {moment(record.oggExpireDate).format("DD.MM.YYYY")}
                                                                    </span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.birthDate ? moment(record.birthDate).format("DD.MM.YYYY") : "-"}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{(record.personnelType == "1" ? "Amir" : record.personnelType == "3" ? "Özel Güvenlik Sorumlusu" : "Özel Güvenlik") + (record.isRetired ? " (Emekli)" : "")}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{record.eventSupplierName}</td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm">
                                                        <ConfirmButton onConfirm={() => onDeleteConfirm(record.uniqueKey)} message="Personeli listeden çıkartmak istediğinizden emin misiniz ?">
                                                            <button
                                                                className="text-red-500 hover:text-red-700 p-1"
                                                            >
                                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                                                            </button>
                                                        </ConfirmButton>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <QrScannerModal
                isOpen={isQrScannerOpen}
                onClose={() => setIsQrScannerOpen(false)}
                onScanSuccess={handleQrScanSuccess}
            />
        </div>
    );
};
